import API from '@/views/Fdc/Apis'
import LiveFaultDetectionStatus from '@/views/Fdc/Dashboard/Components/LiveFaultDetectionStatus'
import LiveFaultDetail from '@/views/Fdc/Dashboard/Components/LiveFaultDetail'
import DetectionModelRank from '@/views/Fdc/Dashboard/Components/DetectionModelRank'
import MonthlyFaultStatsByFab from '@/views/Fdc/Dashboard/Components/MonthlyFaultStatsByFab'
import MonthlyFaultStatsByArea from '@/views/Fdc/Dashboard/Components/MonthlyFaultStatsByArea'
import DailyFaultStatsOfArea from '@/views/Fdc/Dashboard/Components/DailyFaultStatsOfArea'

/**
 * Dashboard > Dashboard
 */
export default {
  name: 'DashboardMonitor',
  components: {
    'live-fault-detection-status': LiveFaultDetectionStatus, // 실시간 이상 검출 건수 component
    'live-fault-detail': LiveFaultDetail, // 이상 검출 목록 component
    'detection-model-rank': DetectionModelRank, // 이상 검출 모델 TOP 10 component
    'monthly-fault-stats-by-fab': MonthlyFaultStatsByFab, // 월별 전체 이상 검출 건수 component
    'monthly-fault-stats-by-area': MonthlyFaultStatsByArea, // 월별 Area 이상 검출 건수 component
    'daily-fault-stats-of-area': DailyFaultStatsOfArea // 일별 이상 검출 건수 component
  },
  mounted () {
    this.search()
  },
  methods: {
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    // liveFaultDetectionStatusSelected (info) {
    //   this.liveFaultDetectionStatusData = info
    // },
    // liveFaultDetailSelected (info) {
    //   this.liveFaultDetailData = info
    // },
    // detectionModelRankSelected (info) {
    //   this.detectionModelRankData = info
    // },
    /**
     * 월별 전체 이상 검출 건수 chart selection event
     * @param {*} info 선택 된 chart point data
     */
    monthlyFaultStatsByFabSelected (info) {
      this.monthlyFaultStatsByFabData = info
    },
    /**
     * 월별 Area 이상 검출 건수 chart selection event
     * @param {*} info 선택 된 chart point data
     */
    monthlyFaultStatsByAreaSelected (info) {
      this.monthlyFaultStatsByAreaData = info
    },
    /**
     * Dashboard data 조회
     * Equipment Run Status / Fault Detection Model / Fault Detection / Fault Alarm 현황을 조회합니다.
     */
    async search () {
      const payload = {
        fab: 'BRIQUE'
      }
      await API.Monitor.getSetInfo({}, this.callbackSettingInfo)
      await API.Monitor.getEqpStatus(payload, this.callbackEqpStatus)
      await API.Monitor.getModelStatus(payload, this.callbackModelStatus)
      await API.Monitor.getDetectionStatus(payload, this.callbackDetectionStatus)
      await API.Monitor.getAlarmStatus(payload, this.callbackAlarmStatus)
    },
    /**
     * Equipment Run Status 조회 callback
     * @param {*} response Equipment Run Status 조회 결과
     */
    callbackEqpStatus (response) {
      if (response && response.status === 200) {
        this.totCnt = response.data.totCnt
        this.runCnt = response.data.runCnt
      }
    },
    /**
     * Fault Detection Model 조회 callback
     * @param {*} response Fault Detection Model 조회 결과
     */
    callbackModelStatus (response) {
      if (response && response.status === 200) {
        let mTotCnt = response.data.mTotCnt ? response.data.mTotCnt : 0
        let uTotCnt = response.data.uTotCnt ? response.data.uTotCnt : 0
        let mActCnt = response.data.mActCnt ? response.data.mActCnt : 0
        let uActCnt = response.data.uActCnt ? response.data.uActCnt : 0
        this.modelTotCnt = mTotCnt + uTotCnt
        this.modelActCnt = mActCnt + uActCnt
      }
    },
    /**
     * Fault Detection 조회 callback
     * @param {*} response Fault Detection 조회 결과
     */
    callbackDetectionStatus (response) {
      if (response && response.status === 200) {
        this.faultCnt = response.data.faultCnt
        this.warningCnt = response.data.warningCnt
      }
    },
    /**
     * Fault Alarm 조회 callback
     * @param {*} response Fault Alarm 조회 결과
     */
    callbackAlarmStatus (response) {
      if (response && response.status === 200) {
        this.eqpAlarmCnt = response.data.eqpAlarmCnt
        this.faultAlarmCnt = response.data.faultAlarmCnt
      }
    },
    callbackSettingInfo (response) {
      if (response && response.status === 200) {
        var fab = response.data.fab
        var periodStart = response.data.periodStart
        var formattedStart = periodStart.substring(0, 4) + '-' + periodStart.substring(4, 6) + '-' + periodStart.substring(6, 8)
        var periodEnd = response.data.periodEnd
        var formattedEnd = periodEnd.substring(0, 4) + '-' + periodEnd.substring(4, 6) + '-' + periodEnd.substring(6, 8)
        var title = 'Fab : ' + fab
        if (response.data.dashboardType === 'NOW') {
          title += ', PERIOD : 최근 1주일'
        } else if (response.data.dashboardType === 'PERIOD') {
          title += ', PERIOD : ' + formattedStart + ' ~ ' + formattedEnd
        }
        this.setInfo = title
      }
    }
  },
  data () {
    return {
      // liveFaultDetectionStatusData: null,
      // liveFaultDetailData: null,
      // detectionModelRankData: null,
      monthlyFaultStatsByFabData: null, // 선택된 월별 전체 이상 검출 건수 chart point data
      monthlyFaultStatsByAreaData: null, // 선택된 월별 Area 이상 검출 건수 chart point data
      totCnt: '-', // Equipment Run Status Total EQP count
      runCnt: '-', // Equipment Run Status Run EQP count
      modelTotCnt: '-', // Fault Detection Model Total count
      modelActCnt: '-', // Fault Detection Model Run count
      faultCnt: '-', // Fault Detection Fault count
      warningCnt: '-', // Fault Detection Warning count
      eqpAlarmCnt: '-', // EQP Alarm count
      faultAlarmCnt: '-', // Fault Alarm count
      setInfo: null // 서버 setting 정보
    }
  }
}
